/**
 * Constants for the ManageUsers component
 */

/** Minimum number of characters required before triggering user search */
export const USER_SEARCH_MIN_LENGTH = 2;

/** Maximum number of search results to return */
export const DEFAULT_SEARCH_LIMIT = 20;

/** Time in milliseconds to cache search results */
export const SEARCH_CACHE_TIME = 30000; // 30 seconds

/** Value used to identify admin checkbox selection */
export const ADMIN_CHECKBOX_VALUE = 'is_admin';

/**
 * Translation keys required by this component
 *
 * @see src/i18n/index.ts for the actual translations
 */
export const TRANSLATION_KEYS = {
  // Error messages
  USER_SEARCH_FAILED: 'orgs:user_search_failed',
  USER_SEARCH_INVALID_RESPONSE: 'orgs:user_search_invalid_response',
  PLEASE_SELECT_USER: 'orgs:please_select_user',
  USER_ADDED_FAILED: 'orgs:user_added_failed',
  USER_REMOVED_FAILED: 'orgs:user_removed_failed',

  // Success messages
  USER_ADDED_SUCCESS: 'orgs:user_added_success',
  USER_REMOVED_SUCCESS: 'orgs:user_removed_success',

  // UI labels and placeholders
  SEARCH_USER_PLACEHOLDER: 'orgs:search_user_placeholder',
  SEARCH_USER_DESCRIPTION: 'orgs:search_user_description',
  USER_PERMISSIONS: 'orgs:user_permissions',
  NO_USERS_IN_ORG: 'orgs:no_users_in_org',

  // General actions
  ADDING: 'general:adding',
  REMOVING: 'general:removing',
  ADD_USER: 'general:add_user',
  CURRENT_USERS: 'general:current_users',
  SEARCH_USER: 'general:search_user',
  IS_ADMIN: 'general:is_admin',
  NAME: 'general:name',
  EMAIL: 'general:email',
  ROLE: 'general:roles',
  ACTIONS: 'general:actions',
} as const;
